export const CleanFirebaseAuthErrorMessage = (message) => {
	let removeAuth = message.replace('auth/', '')
	let removeDash = removeAuth.replace(/-/g, ' ')
	let formattedMessage = removeDash[0].toUpperCase() + removeDash.slice(1) + '.'
	return formattedMessage
}
